import { noun } from 'plural-ru';

export const pluralizeNumber = number => noun(number, 'балл', 'балла', 'баллов');

export default pluralizeNumber;
